import {post} from '../utils/request'


export async function gettopperformancebranch(data) {
    return await post('api/v1/smartscreen/gettopperformancebranch',data)
}

export async function getdaysaleanalysis(data) {
    return await post('api/v1/smartscreen/getdaysaleanalysis',data)
}

export async function gettopperformancecategory(data) {
    return await post('api/v1/smartscreen/gettopperformancecategory',data)
}

export async function getmonthsalessummary(data) {
    return await post('api/v1/smartscreen/getmonthsalessummary',data)
}

export async function gettopperformancebrand(data) {
    return await post('api/v1/smartscreen/gettopperformancebrand',data)
}

export async function gettopperformancegroup(data) {
    return await post('api/v1/smartscreen/gettopperformancegroup',data) 
}